<template #contentTemplate="{}">
  <div>
      <div v-if="open" class="modal--backdrop" @click="open = false"></div>
      <div v-if="open" class="card combobox">
        <BasicTextInput 
          :customStyles="{marginBottom: '10px'}"
          label="Customer" placeholder="search..." :focus="true" @change="debounce(customInputChanged, 500)" v-model="customInput"/>
        <DxDataGrid
          :data-source="dataSource"
          :height="200"
          width="100%"
          :row-alternation-enabled="true"
          :selected-row-keys="[currentValue]"
          :hover-state-enabled="true"
          :focused-row-enabled="true"
          :onRowClick="onSelectionChanged"
          :focused-row-key="currentValue"
          :show-borders="true"

          :remoteOperations="true"
          key-expr="Name"
        >
          <DxSearchPanel :text="searchInput" :visible="false" :width="460"/>
          <DxColumn :width="50" data-field="Id" cell-template="grid-cell"/>
          <DxColumn :width="75" data-field="JdeNum" cell-template="grid-cell"/>
          <DxColumn :width="150" data-field="Name" cell-template="grid-cell"/>
          <DxColumn :width="120" data-field="CustomerContactName" cell-template="grid-cell"/>
          <DxColumn :width="60" caption="Private" data-field="IsPrivate" cell-template="grid-cell-private"/>
          <template  #grid-cell="{ data }">
            <div class="cell" style="fontSize:10px">{{ data.text }}</div>
          </template>
          <template  #grid-cell-private="{ data }">
              <div class="cell">
                <i :class="data.value ? 'fa fa-check' : 'fa fa-times'" aria-hidden="true"></i>
              </div>
          </template>
          <DxScrolling mode="virtual"/>
          <DxPaging
            :enabled="true"
            :page-size="50"
          />
        </DxDataGrid>
        <span class="my-2"></span>
        <button type="button" class="btn btn-primary" @click="$emit('toggleAddCustomerModal')">Add New Customer</button>
        <span class="my-1"></span>
        
      </div>
    </div>
</template>
<script>

import {
  DxDataGrid,
  DxPaging,
  DxSelection,
  DxScrolling,
  DxColumn,
  DxSearchPanel
}                             from 'devextreme-vue/data-grid';
import DxDropDownBox          from 'devextreme-vue/drop-down-box';
import BasicTextInput         from '../components/inputComponents/BasicTextInput.vue';
import { CustomerService }    from '@/services';
import { on, off }            from "devextreme/events";

const dropDownBoxRefName = 'customerSearchDropdown';

export default {
  components: {
    DxSearchPanel,
    DxDataGrid,
    DxPaging,
    DxSelection,
    DxScrolling,
    DxColumn,
    DxDropDownBox,
  },
  props: {
    value: {
      type: String,
      default: null
    },
    onValueChanged: {
      type: Function,
      default: () =>  {}
    },
  },
  data() {
    return {
      dataSource: [],
      searchInput: '',
      open: false,
      currentValue: null,
      dropDownOptions: { width: 500 },
      dropDownBoxRefName,
      customInput: '',
      timerId: null,
    };
  },
  
  methods: {
    debounce(func, wait) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(func, wait)
    },

    onSelectionChanged(selectionChangedArgs) {
      if(!selectionChangedArgs) return;
      this.$emit('customerSelected', selectionChangedArgs.data)
      this.toggle()
    },

    toggle(){
        this.open = !this.open;
    },
    customInputChanged(){
        this.searchInput = this.customInput;
        this.currentValue = this.customInput;
        this.onValueChanged(this.currentValue)
      
      
    },
    getCustomers(){
      this.dataSource = CustomerService.getDataSource();
    },
  },
  // watch: {
  //   customInput: function() {
  //     console.log('happens')
  //   }
  // },
  created(){
    this.currentValue = this.value;
    this.getCustomers();
  },
};
</script>
<style lang="scss" scoped>
  .modal--backdrop {
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    min-width: 100%;
    z-index: 100;
    opacity: 0;
    
  }
  .combobox {
    position: absolute;
    z-index: 100;
    width: 500px;
    height: 400px;
    padding: 20px;
  }
  .header {
    color: $primary;
    font-size: 12px;
  }
  .cell {
    color: $ss_grey1;
    font-size: 10px;
  }
</style>